import { render } from "./Navigation.vue?vue&type=template&id=0bc594b0"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=0bc594b0&lang=css"
script.render = render

export default script